import {$, HttpIgnore, Model, ResponseFill} from 'simpli-web-sdk'
import ConfigNovaSla from '@/model/resource/ConfigNovaSla'

@HttpIgnore()
export default class PersistConfigNovaSlaRequest extends Model {
  readonly $name: string = 'PersistConfigNovaSlaRequest'

  @ResponseFill()
  config: ConfigNovaSla[] = []

  async persist(spinner = 'persistConfigNovaSlaUpload') {
    const fetch = () => this.POST('/user/config-nova-sla', this)

    return await $.await.run(fetch, spinner)
  }
}
